import { Input, type InputProps } from 'chakra-ui-next'
import { withMask } from 'use-mask-input'

interface PhoneInputProps extends InputProps {
  country?: string | null
  disabled?: boolean
}

export function PhoneInput({ country = 'US', ...props }: PhoneInputProps) {
  let phoneMask: string
  switch (country) {
    case 'US':
      phoneMask = '(999) 999-9999'
      break
    default:
      phoneMask = ''
      break
  }

  return (
    <Input
      {...props}
      placeholder="(999) 999-9999"
      ref={withMask(phoneMask, { autoUnmask: true })}
    />
  )
}
